import { StyledDrawer } from '../../Molecules/Drawer/styles'
import { StyledModal } from '../../Molecules/Modal/styles'
import { styled } from '../../Styles/stitches.config'
import { StyledImage } from '../../Atoms/Image/styles'
import { StyledSVG } from '../../Atoms/SVG/styles'

export const CloseButton = styled('div', {
    color: '$primary600',
    cursor: 'pointer',
    position: 'absolute',
    right: '$3',
    top: '$3',
})

export const Header = styled('div', {
    alignItems: 'end',
    display: 'flex',
    gap: '$3',

    [`& ${StyledImage}`]: {
        br: '50%',
        size: 100,
    },
})

export const StyledPackageModal = styled('div', {
    [`& ${StyledModal}, ${StyledDrawer}`]: {
        alignContent: 'start',
        borderTop: 0,
        display: 'grid',
        gap: '$3',

        '&:before': {
            content: `''`,
            inset: 0,
            position: 'absolute',
            zIndex: -1,
        },
    },
    [`& ${Header}`]: {
        [`& ${StyledSVG}`]: {
            top: 'calc($3)',
        },
    },

    '@desktop': {
        [`& ${StyledModal}`]: {
            top: '10%',
            transform: 'translateX(-50%)',
        },
    },

    '@mobile': {
        [`& ${StyledModal}`]: {
            top: 0,
            transform: 'translate(-50%, 0)',
        },

        [`& ${StyledDrawer}`]: {
            inset: 'auto 0',
            minH: 'calc(100% - 55px)',
            overflow: 'hidden auto',
        },
    },
})
